module.exports = __webpack_public_path__ + "img/ep-etoile-3.aea9857d.jpg";